import React from 'react';
import DocumentationType from './Type';
import { root } from '../utils/Manager';

export function TypeParams({ params }) {
    if (!params) return null;
    const li = params.length - 1;
    
    return <>
        <strong>{'<'}</strong>
        {params.map((t, i) => [t.name, t.extends ? [' extends ', <DocumentationType type={t.extends}/>] : null, i === li ? null : <strong>, </strong>])}
        <strong>{'>'}</strong>
    </>
}

export function Source({ sources, size = 20 }) {
    if (!sources || sources.fileName.includes('node_modules')) return null;
    const pathSuffix = `${sources.fileName}#L${sources.line}`;
    return <a href={root + pathSuffix} style={{ fontSize: size + 'px' }}>{pathSuffix}</a>;
}

export function Example({ comment = {} }) {
    if (!comment.tags) return null;
    let example = comment.tags.find(t => t.tag === "example");
    return example
            ? <pre><code className="js">{example.text}</code></pre>
            : null;
}